// composables/useAuthStore.js
export default function useAuth() {
  const userInfo = ref(JSON.parse(sessionStorage.getItem('userInfo') || 'null'));

  return {
    userInfo,
  };
}

export const getUserLogin = async () => {
  const userInfo = JSON.parse(sessionStorage.getItem('userInfo') || 'null');
  return userInfo?.id;
};
